import { createRoot } from "react-dom/client"
import App from "./App";
import config from "../../info/default.json";

const container = document.getElementById("app");
const root = createRoot(container)

root.render(<App config={config}/>);